<div class="p-8 w-100">
    <div class="fs-2 fw-bolder text-center w-100 text-dark"> {{ 'DEFINE_COVER_QUESTION' | translate }} </div>
    <div class="text-center mt-5">
        <div class="fs-4 fw-bold text-dark"> {{ periodLabel }} </div>
        <div class="fs-1 lh-1 mt-2 fw-bolder text-primary">{{price.basePrice | energy:'price'}} {{ 'price' | energyUnit }}</div>
        <div class="fs-7 text-muted mt-1"> {{ 'DEFINE_COVER_PRICE_EXPLANATION' | translate }} </div>
    </div>

    <div class="mt-8 fs-5 fw-bold text-dark"> {{ 'COVER_PERCENTAGE' | translate }} </div>
    <div class="row cover-percentages mt-3">
        <div class="col-6 p-2" *ngFor="let percentage of percentages">
            <div class="py-3 px-2 flex-column align-items-center" [class.active]="selectedPercentage == percentage" [class.unavailable]="percentage > maxAvailablePercentage" (click)="percentage <= maxAvailablePercentage && selectPercentage(percentage)">
                <span class="fs-3 fw-bold"> {{percentage}}% </span>
                <span class="fs-8 option-detail" *ngIf="totalConsumption > 0">
                    ≈ {{ getProtectedConsumption(percentage) | energy:'consumption' }} {{ 'consumption' | energyUnit }} · {{ getProtectedCost(percentage) | number:'1.0-0' }} €
                </span>
            </div>
        </div>
    </div>
    <div class="fs-7 text-muted mt-2" *ngIf="maxAvailablePercentage < 100">
        <i class="fas fa-circle-info me-1"></i>
        {{ (maxAvailablePercentage > 0 ? 'COVER_MAX_AVAILABLE' : 'COVER_NOTHING_AVAILABLE') | translate: { percentage: maxAvailablePercentage } }}
    </div>

    <div class="bg-light monthly-covers-block mt-6 p-4 rounded-1">
        <div class="fw-bold fs-6 text-dark">
            {{ 'PROTECTION_PER_MONTH' | translate }}
        </div>
        <div class="fs-8 text-muted mb-3"> {{ 'PROTECTION_PER_MONTH_HINT' | translate }} </div>
        <div class="cover-listing">
            <div *ngFor="let year of coversByYears | keyvalue" class="mb-3">
                <div class="fw-bold fs-7 mb-1"> {{ year.key }} </div>
                <div class="month-bars">
                    <div *ngFor="let cover of year.value" class="month-bar" [class.is-alert]="cover.projectedCover > 100">
                        <div class="month-bar-track">
                            <div class="month-bar-new" [style.height.%]="cover.projectedCover > 100 ? 100 : cover.projectedCover"></div>
                            <div class="month-bar-existing" [style.height.%]="cover.cover"></div>
                        </div>
                        <div class="fs-9 text-center text-muted"> {{ cover.monthAsFormattedString }} </div>
                        <div class="fs-9 text-center fw-bold"> {{ cover.projectedCover }}% </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-wrap gap-4 fs-8 text-muted">
            <span><span class="legend-swatch existing"></span> {{ 'ALREADY_PROTECTED' | translate }}</span>
            <span><span class="legend-swatch new"></span> {{ 'THIS_PRICE' | translate }}</span>
        </div>
    </div>

    <div class="text-danger fs-7 mt-3" *ngIf="coverPercentageOverTreshold">
        <i class="fas fa-triangle-exclamation text-danger me-1"></i> {{ 'COVER_OVER_100_MESSAGE' | translate }}
    </div>

    <div class="row cover-percentages mt-5">
        <div class="col-6 p-2 fs-4">
            <button class="py-3 btn btn-primary" [class.disabled]="coverPercentageOverTreshold || selectedPercentage == 0 || selectedPercentage == null" (click)="closeDialog(true)">
                {{'APPLY' | translate}}
            </button>
        </div>
        <div class="col-6 p-2 fs-4">
            <button class="py-3 btn btn-secondary" (click)="closeDialog(false)">
                {{'CANCEL' | translate}}
            </button>
        </div>
    </div>
</div>
